import React, { useState } from "react";
import { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Card, CardBody, Row, Col, Button, Badge, Container } from "reactstrap";
import BranchService from "../../../services/KangarooServices/BranchService";
import BreadCrumb from "../../../Components/Common/BreadCrumb";
import { imageBaseApi } from "../../../utilis/imageHelper";
import { Edit3 } from "lucide-react";

const BranchDetail = () => {
  const [data, setData] = useState([]);
  const { id } = useParams();
  const navigate = useNavigate()
  useEffect(() => {
    const fetchDataById = async (branchId) => {
      const res = await BranchService.getDetail(branchId);
      setData(res);
    };
    fetchDataById(id);
  }, [id]);
  return (
    <div className="page-content">
      <Container fluid>
        <BreadCrumb
          title="Details"
          pageTitle="Branch Location"
          breadcrumbItems={[{ title: "Back to List", link: "/branch" }]}
        />
        <Row>
          {/* Hero Section */}
          <Col lg={12}>
            <Card className="border-0 shadow-sm overflow-hidden mb-4 rounded-4">
              <CardBody>
                <div
                  className="d-flex flex-column justify-content-center "
            
                >
                  {/* Top Section */}
                  <div className="d-flex align-items-center gap-3 mb-3">
                     <div className="position-absolute  me-3" style={{ right: "0",zIndex: 100 }}>

                <button
                        type="button"
                        className="btn btn-sm btn-primary d-flex align-items-center gap-1"
                        onClick={() => navigate(`/addbranch/${id}`)}
                        style={{ fontSize: "0.875rem" }}
                      >
                        <Edit3 size={14} />
                        Update 
                      </button>
                </div>
                    {data.media?.url && (
                      <div
                        className="position-relative bg-white shadow-sm rounded-4 d-flex align-items-center justify-content-center"
                        style={{
                          width: "70px",
                          height: "70px",
                          overflow: "hidden",
                          border: "1px solid #eee",
                        }}
                      >
                        <img
                          src={`${imageBaseApi}${data?.media?.url}`}
                          alt={data.officeName}
                          className="img-fluid"
                          style={{
                            objectFit: "contain",
                            width: "80%",
                            height: "80%",
                          }}
                        />
                      </div>
                    )}

                    <h3 className="mb-0 fw-semibold text-dark">
                      {data.officeName}
                    </h3>
                  </div>

                  {/* Badges Section */}
                  <div className="d-flex flex-wrap align-items-center gap-2">
                    <Badge
                      pill
                      className="bg-light text-dark d-flex align-items-center px-3 py-2 shadow-sm"
                    >
                      <i className="ri-map-pin-line me-1"></i>
                      {data.city}, {data.country}
                    </Badge>

                    {data.isActive && (
                      <Badge
                        pill
                        className="bg-light text-success d-flex align-items-center px-3 py-2 shadow-sm"
                      >
                        <i className="ri-checkbox-circle-line me-1"></i>
                        Active
                      </Badge>
                    )}
                  </div>
                </div>
              </CardBody>
            </Card>
          </Col>

          {/* Main Content */}
          <Col lg={8}>
            {/* Office Image */}

            {/* Contact Information */}
            <Card className="border-0 shadow-sm mb-4">
              <CardBody className="p-4">
                <div className="d-flex align-items-center mb-4">
                  <div className="bg-primary bg-opacity-10 rounded p-2 me-3">
                    <i
                      className="ri-contacts-line text-primary"
                      style={{ fontSize: "24px" }}
                    ></i>
                  </div>
                  <h5 className="mb-0 fw-semibold">Contact Information</h5>
                </div>

                <Row className="g-4">
                  <Col md={6}>
                    <div className="bg-light rounded p-3 h-100">
                      <div className="d-flex align-items-start">
                        <div className="bg-primary bg-opacity-25 rounded p-2 me-3">
                          <i className="ri-map-pin-2-fill text-primary"></i>
                        </div>
                        <div>
                          <label className="text-muted small mb-1">
                            Address
                          </label>
                          <p className="fw-semibold mb-0">{data.address}</p>
                          <p className="text-muted mb-0 small">
                            {data.city}, {data.country}
                          </p>
                        </div>
                      </div>
                    </div>
                  </Col>

                  <Col md={6}>
                    <div className="bg-light rounded p-3 h-100">
                      <div className="d-flex align-items-start">
                        <div className="bg-success bg-opacity-25 rounded p-2 me-3">
                          <i className="ri-phone-fill text-success"></i>
                        </div>
                        <div>
                          <label className="text-muted small mb-1">Phone</label>
                          <p className="fw-semibold mb-0">
                            <a
                              href={`tel:${data.phone}`}
                              className="text-decoration-none text-dark"
                            >
                              {data.phone}
                            </a>
                          </p>
                        </div>
                      </div>
                    </div>
                  </Col>

                  <Col md={6}>
                    <div className="bg-light rounded p-3 h-100">
                      <div className="d-flex align-items-start">
                        <div className="bg-info bg-opacity-25 rounded p-2 me-3">
                          <i className="ri-mail-fill text-info"></i>
                        </div>
                        <div>
                          <label className="text-muted small mb-1">Email</label>
                          <p className="fw-semibold mb-0">
                            <a
                              href={`mailto:${data.email}`}
                              className="text-decoration-none text-dark"
                            >
                              {data.email}
                            </a>
                          </p>
                        </div>
                      </div>
                    </div>
                  </Col>

                  <Col md={6}>
                    <div className="bg-light rounded p-3 h-100">
                      <div className="d-flex align-items-start">
                        <div className="bg-warning bg-opacity-25 rounded p-2 me-3">
                          <i className="ri-time-fill text-warning"></i>
                        </div>
                        <div>
                          <label className="text-muted small mb-1">
                            Opening Hours
                          </label>
                          <p className="fw-semibold mb-0">
                            {data.openingHours}
                          </p>
                        </div>
                      </div>
                    </div>
                  </Col>
                </Row>

                <div className="mt-4 pt-3 border-top">
                  <Button
                    color="primary"
                    className="d-flex align-items-center"
                    onClick={() => window.open(data.googleMapUrl, "_blank")}
                  >
                    <i className="ri-map-pin-line me-2"></i>
                    View on Google Maps
                  </Button>
                </div>
              </CardBody>
            </Card>

            {/* Office Head */}
            <Card className="border-0 shadow-sm">
              <CardBody className="p-4">
                <div className="d-flex align-items-center mb-3">
                  <div className="bg-primary bg-opacity-10 rounded p-2 me-3">
                    <i
                      className="ri-user-star-line text-primary"
                      style={{ fontSize: "24px" }}
                    ></i>
                  </div>
                  <h5 className="mb-0 fw-semibold">Office Head</h5>
                </div>

                <div className="d-flex align-items-center bg-light rounded p-4">
                  <div
                    className="avatar-lg rounded-circle bg-primary bg-opacity-25 text-primary d-flex align-items-center justify-content-center fw-semibold me-3"
                    style={{ fontSize: "24px" }}
                  >
                    {data.officeHeadName
                      ?.split(" ")
                      .map((n) => n.charAt(0))
                      .join("")}
                  </div>
                  <div>
                    <h6 className="mb-1 fw-semibold">{data.officeHeadName}</h6>
                  </div>
                </div>
              </CardBody>
            </Card>
          </Col>

          {/* Sidebar */}
          <Col lg={4}>
            {/* Quick Actions */}
            {/* <Card className="border-0 shadow-sm mb-4">
            <CardBody className="p-4">
              <h6 className="fw-semibold mb-3">Quick Actions</h6>
              <div className="d-grid gap-2">
                <Button
                  color="success"
                  className="d-flex align-items-center justify-content-center"
                  onClick={() => (window.location.href = `tel:${data.phone}`)}
                >
                  <i className="ri-phone-line me-2"></i>
                  Call Now
                </Button>
                <Button
                  color="info"
                  className="d-flex align-items-center justify-content-center text-white"
                  onClick={() =>
                    (window.location.href = `mailto:${data.email}`)
                  }
                >
                  <i className="ri-mail-line me-2"></i>
                  Send Email
                </Button>
                <Button
                  color="secondary"
                  className="d-flex align-items-center justify-content-center"
                  onClick={() => window.open(data.googleMapUrl, "_blank")}
                >
                  <i className="ri-navigation-line me-2"></i>
                  Get Directions
                </Button>
              </div>
            </CardBody>
          </Card> */}

            {/* Office Details */}
            <Card className="border-0 shadow-sm mb-4">
              <CardBody className="p-4">
                <h6 className="fw-semibold mb-3">Office Details</h6>

                <div className="mb-3">
                  <label className="text-muted small mb-1 d-flex align-items-center">
                    <i className="ri-calendar-line me-1"></i>
                    Created At
                  </label>
                  <p className="fw-semibold mb-0 small">
                    {new Date(data.createdAt).toLocaleString()}
                  </p>
                </div>

                <div className="mb-3">
                  <label className="text-muted small mb-1 d-flex align-items-center">
                    <i className="ri-calendar-check-line me-1"></i>
                    Updated At
                  </label>
                  <p className="fw-semibold mb-0 small">
                    {data.updatedAt
                      ? new Date(data.updatedAt).toLocaleString()
                      : "Not updated yet"}
                  </p>
                </div>

                <div className="mb-3">
                  <label className="text-muted small mb-1 d-flex align-items-center">
                    <i className="ri-toggle-line me-1"></i>
                    Status
                  </label>
                  <Badge
                    color={data.isActive ? "success" : "danger"}
                    className="px-3 py-2"
                  >
                    {data.isActive ? "Active" : "Inactive"}
                  </Badge>
                </div>

                {data.media && (
                  <div>
                    <label className="text-muted small mb-1 d-flex align-items-center">
                      <i className="ri-image-line me-1"></i>
                      Media File
                    </label>
                    <p className="fw-semibold mb-0 small text-break">
                      {data.media.fileName}
                    </p>
                  </div>
                )}
              </CardBody>
            </Card>

            {/* Map Preview */}
            <Card className="border-0 shadow-sm">
              <CardBody className="p-0">
                <iframe
                  src={data.googleMapUrl}
                  width="100%"
                  height="250"
                  style={{ border: 0 }}
                  allowFullScreen=""
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                  className="rounded"
                ></iframe>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default BranchDetail;
